var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"themeMenu"},[_c('div',{staticClass:"button",on:{"click":_vm.switchTheme}},[_c('i',{staticClass:"fa",class:_vm.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }